/**
 * Returns an array of key-value pairs for every entry in the list, or an empty array if no
 * entries in list is specified.
 */
export const toUrlSearchParams = (key: string, list?: string[]) => [
  ...(list ?? []).map((x) => [key, x]),
];
